import { InjectionToken, Signal } from '@angular/core';

/** Whether the content it is provided to is showing, from a container that hides content and keeps it alive. */
export interface RadActiveState {
    /** False while the content is hidden, so it can pause its polling. */
    readonly active: Signal<boolean>;
}

/** Injected optionally by content that pauses while hidden. Absent outside such a container, where the content is always showing. */
export const RAD_ACTIVE = new InjectionToken<RadActiveState>('RAD_ACTIVE');
